import { useTranslate } from '@tolgee/react';
import { Select, SelectProps } from 'antd';
import { useRef, useState } from 'react';
import { StyledTag } from '../ImplementData/components/Filter/DepartmentSelect';

function ScoreSelect({
  platform,
  value: valueProp,
  onChange: onChangeProp,
  onBlur,
  ...otherProps
}: Omit<SelectProps<number[]>, 'onChange'> & {
  platform: General.PlatformUpperCase;
  onChange: (value: number[]) => void;
}) {
  const { t } = useTranslate();

  const refsCurrent = { valueProp, onChangeProp };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  const [value, setValue] = useState(valueProp);

  const options =
    platform === 'SHOPEE'
      ? [
          { value: 2, label: t('review.好评') },
          { value: 1, label: t('一般') },
          { value: 0, label: t('aide.差评') },
        ]
      : [
          { value: 6, label: t('3星及以下') },
          { value: 5, label: t('review.x星', { count: 5 }) },
          { value: 4, label: t('review.x星', { count: 4 }) },
          { value: 3, label: t('review.x星', { count: 3 }) },
          { value: 2, label: t('review.x星', { count: 2 }) },
          { value: 1, label: t('review.x星', { count: 1 }) },
        ];

  return (
    <Select
      className="w-48"
      allowClear
      mode="multiple"
      maxTagCount="responsive"
      placeholder={t('选择评分等级')}
      options={options}
      value={value}
      onChange={setValue}
      onBlur={(e) => {
        if (value !== valueProp) {
          onChangeProp(value || []);
        }

        if (onBlur) {
          onBlur(e);
        }
      }}
      onClear={() => {
        onChangeProp([]);
      }}
      tagRender={({ label }) => <StyledTag>{label}</StyledTag>}
      {...otherProps}
    />
  );
}

export default ScoreSelect;
